module.exports = require('./_hide');


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/core-js/library/modules/_redefine.js
 ** module id = 51
 ** module chunks = 1
 **/